import { DocumentIcon } from "@heroicons/react/24/solid";

interface UploadedFileProps {
  title: string;
  url: string;
  onDelete: () => void;
}
const UploadedFile = ({ title, url, onDelete }: UploadedFileProps) => {
  return (
    <div className="flex flex-row gap-5 items-center">
      <a
        href={url}
        target="_blank"
        className="flex flex-row items-center gap-1 font-medium font-noto text-blue-500 underline text-[14px]"
      >
        <DocumentIcon className="h-4 w-4 text-gray-900" />
        {title}
      </a>
      <div className="flex items-center">
        <button
          type="button"
          className="text-red-500 underline text-[14px]"
          onClick={onDelete}
        >
          ลบ
        </button>
      </div>
    </div>
  );
};

export default UploadedFile;
